import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "rasin_install_dismissed";

export default function InstallPrompt() {
  const [evt, setEvt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(DISMISS_KEY) === "1") return;

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setEvt(e);
      setVisible(true);
    };
    const onInstalled = () => {
      setVisible(false);
      setEvt(null);
      localStorage.setItem(DISMISS_KEY, "1");
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!evt) return;
    evt.prompt();
    try {
      await evt.userChoice;
    } catch {
      /* ignore */
    }
    setEvt(null);
    setVisible(false);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  if (!visible) return null;

  return (
    <div
      data-testid="pwa-install-prompt"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 bg-[#141414] border border-[#ff4500]/60 shadow-2xl p-4 rounded-sm"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 flex flex-col overflow-hidden flex-shrink-0">
          <div className="flex-1 bg-[#00209F]" />
          <div className="flex-1 bg-[#D21034]" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#ff4500] font-mono">
            Install Rasin
          </div>
          <div className="text-sm text-white mt-1 leading-snug">
            Add Rasin to your home screen — offline shortcut, faster launch.
          </div>
          <div className="mt-3 flex gap-2">
            <button
              onClick={install}
              data-testid="pwa-install-btn"
              className="inline-flex items-center gap-2 px-4 py-2 bg-[#ff4500] hover:bg-[#ff5722] text-white text-[11px] uppercase tracking-[0.2em]"
            >
              <Download className="w-3.5 h-3.5" /> Install
            </button>
            <button
              onClick={dismiss}
              data-testid="pwa-install-dismiss"
              className="px-4 py-2 text-[11px] uppercase tracking-[0.2em] text-[#a3a3a3] hover:text-white border border-[#2a2a2a]"
            >
              Not now
            </button>
          </div>
        </div>
        <button onClick={dismiss} className="text-[#a3a3a3] hover:text-white" aria-label="Close">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
